export const formatImageUrl = (url) => {
    if (!url) return '/logo.png'; // Fallback
    if (url.startsWith('http') || url.startsWith('data:')) return url;

    // Public assets in the frontend should use the local path
    const isPublicAsset = url.startsWith('/assets/') || url.startsWith('/logo.png') || url === 'logo.png';

    // Get API base URL and remove '/api' suffix to get the root host
    const getBaseUrl = () => {
        // In production, use the domain directly
        if (process.env.NODE_ENV === 'production') return 'https://drvivara.cloud';
        if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL.replace('/api', '');
        return '';
    };

    const base = getBaseUrl();
    let cleanUrl = url.startsWith('/') ? url : `/${url}`;

    if (isPublicAsset) return cleanUrl;

    // If the URL already has an /api/ prefix, prepend base URL directly (no path mangling)
    if (cleanUrl.startsWith('/api/')) return `${base}${cleanUrl}`;

    if (!cleanUrl.startsWith('/uploads')) {
        if (cleanUrl.includes('profile-')) {
            cleanUrl = `/uploads/profiles${cleanUrl}`;
        } else if (cleanUrl.includes('doc-') || cleanUrl.includes('document-')) {
            cleanUrl = `/uploads/documents${cleanUrl}`;
        } else {
            cleanUrl = `/uploads${cleanUrl}`;
        }
    }

    return `${base}${cleanUrl}`;
};
